module.exports = __webpack_public_path__ + "static/media/screen-move.003d3020.svg";